import { render, staticRenderFns } from "./DefaultProject.vue?vue&type=template&id=2319b257&scoped=true&"
import script from "./DefaultProject.vue?vue&type=script&lang=js&"
export * from "./DefaultProject.vue?vue&type=script&lang=js&"
import style0 from "./DefaultProject.vue?vue&type=style&index=0&id=2319b257&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2319b257",
  null
  
)

export default component.exports